import { render, staticRenderFns } from "./IOTAFountainDescription.vue?vue&type=template&id=3758bff8&scoped=true&"
import script from "./IOTAFountainDescription.vue?vue&type=script&lang=js&"
export * from "./IOTAFountainDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3758bff8",
  null
  
)

export default component.exports